<template>
  <base-header>
    <ConsoleMenuCompared />
    <div slot="right">
      <gallery-columns-dialog />
    </div>
  </base-header>
</template>

<script>
import GalleryColumnsDialog from "@/components/dialogs/GalleryColumnsDialog";
import BaseHeader from "./AppHeader";
import ConsoleMenuCompared from "./ConsoleMenuCompared.vue";

export default {
  name: "AppHeaderForCompare",
  components: {
    BaseHeader,
    ConsoleMenuCompared,
    GalleryColumnsDialog,
  },
};
</script>
